/**
 * PDP: GLO = bolinhas de cor | Tema = botões de tamanho + sync foto ao mudar cor.
 */
(() => {
  if (!document.querySelector('#MainContent[data-template="product"]')) return;

  const STYLE_ID = 'fagundes-glo-pdp-override';

  const isGloColorBlock = (block) =>
    Boolean(
      block.querySelector(
        '.g-variant-color-detail, .g-variant-color, ul.g-variant-color-detail, ul.g-variant-color'
      )
    );

  const getThemePicker = () =>
    document.querySelector('#MainContent variant-picker[data-template-product-match="true"]');

  const normalize = (value) => value.trim().toLowerCase();

  const findThemeColorInput = (picker, colorValue) => {
    const target = normalize(colorValue);
    return [...picker.querySelectorAll('fieldset.fagundes-variant-option--glo-hidden input[type="radio"]')].find(
      (input) => normalize(input.value) === target
    );
  };

  const syncGloColorToTheme = (colorValue) => {
    const picker = getThemePicker();
    if (!picker || !colorValue) return;

    const themeInput = findThemeColorInput(picker, colorValue);
    if (!themeInput || themeInput.checked) return;

    themeInput.checked = true;
    themeInput.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const readGloColorValue = (target) => {
    if (!(target instanceof Element)) return '';

    if (target instanceof HTMLInputElement && target.type === 'radio') {
      return target.checked ? target.value : '';
    }

    const label = target.closest('label');
    const input = label?.querySelector('input[type="radio"]');
    if (input instanceof HTMLInputElement) return input.value;

    return '';
  };

  const ensureOverrideStyle = () => {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      #MainContent variant-picker { display: block !important; }
      .product-information .globo-swatch-product-detail .swatch--gl:not(:has(.g-variant-color-detail)):not(:has(.g-variant-color)),
      .product-details .globo-swatch-product-detail .swatch--gl:not(:has(.g-variant-color-detail)):not(:has(.g-variant-color)) {
        display: none !important;
      }
    `;
    document.body.appendChild(style);
  };

  const syncProductVariants = () => {
    ensureOverrideStyle();

    document.querySelectorAll('#MainContent variant-picker').forEach((picker) => {
      picker.style.setProperty('display', 'block', 'important');
    });

    document
      .querySelectorAll(
        '.product-information .globo-swatch-product-detail .swatch--gl, .product-details .globo-swatch-product-detail .swatch--gl'
      )
      .forEach((block) => {
        if (isGloColorBlock(block)) {
          block.style.removeProperty('display');
        } else {
          block.style.setProperty('display', 'none', 'important');
        }
      });
  };

  const bindGloColorBridge = () => {
    if (document.body.dataset.fagundesGloBridgeBound === 'true') return;
    document.body.dataset.fagundesGloBridgeBound = 'true';

    document.addEventListener(
      'change',
      (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement)) return;
        if (!target.closest('.globo-swatch-product-detail')) return;
        if (!target.closest('.g-variant-color-detail, .g-variant-color')) return;

        syncGloColorToTheme(target.value);
      },
      true
    );

    document.addEventListener(
      'click',
      (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        if (!target.closest('.globo-swatch-product-detail .g-variant-color-detail, .globo-swatch-product-detail .g-variant-color')) {
          return;
        }

        requestAnimationFrame(() => {
          const checked = target
            .closest('.globo-swatch-product-detail')
            ?.querySelector('.g-variant-color-detail input[type="radio"]:checked, .g-variant-color input[type="radio"]:checked');

          if (checked instanceof HTMLInputElement) {
            syncGloColorToTheme(checked.value);
          } else {
            const colorValue = readGloColorValue(target);
            if (colorValue) syncGloColorToTheme(colorValue);
          }
        });
      },
      true
    );
  };

  syncProductVariants();
  bindGloColorBridge();

  const root = document.querySelector('#MainContent');
  if (!root || typeof MutationObserver === 'undefined') return;

  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      syncProductVariants();

      const checked = document.querySelector(
        '.globo-swatch-product-detail .g-variant-color-detail input[type="radio"]:checked, .globo-swatch-product-detail .g-variant-color input[type="radio"]:checked'
      );
      if (checked instanceof HTMLInputElement) {
        syncGloColorToTheme(checked.value);
      }
    });
  });

  observer.observe(root, { childList: true, subtree: true });
})();
